import * as React from 'react';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { TableContainer, Paper, Toolbar, Typography } from '@mui/material';

import { useSelectedOrganizationData, isRecordFound } from '../../hooks/data-hooks';
import BusinessIcon from '@mui/icons-material/Business';
import { TableDetails } from '../../components/Table/TableDetails';
import userStyles from './UserStyle';

export const ManageUserList: React.FC = () => {
    const { t } = useLanguageLocale();
    const classes = userStyles();
    const selectedOrganization = useSelectedOrganizationData();

    return (
        <>
            <div data-testid="success-body">
                {isRecordFound(selectedOrganization) && (
                    <>
                        <TableContainer component={Paper}>
                            <Toolbar component="div" style={{ paddingLeft: 10 }}>
                                <BusinessIcon className={classes.IconStyle} color="primary"></BusinessIcon>
                                <Typography variant="h6" color="primary" data-testid="organization-name">
                                    {selectedOrganization.value.name} - {t('USERLIST.ALL_LOCATION')}
                                </Typography>
                            </Toolbar>
                            <div data-testid="user-list">
                                <TableDetails />
                            </div>
                        </TableContainer>
                    </>
                )}
            </div>
        </>
    );
};
